import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Montevideo",
  code: COUNTRY_CODE.uy,
  currency: "UYU",
  grammar: "es",
  lang: "es",
  phone_length: 9,
  max_tip: 2000,
  phone_prefix: "+598",
  gateway: {
    base_url: "https://services.rappi.com.uy",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
    cashless_prefix: "/api/ms/cargo-cashless/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/uy/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.uy/",
  aws_location: {
    api_key:
      "v1.public.eyJqdGkiOiIwZTM4NWZhMS00YjdlLTRlYjQtOWEyYS01N2E0MGMzMmE2ZmMifZxxT2C-hwS-PY3ANLe9hL2emAEW0Wi9lt4GHBVaUMym5i8-0Hc1mYv2rUDrkf2JkPhJSuDLRLclQwCvbbm1pi5vyxkPmOxHGhty65T4uflOOQG86vazQVg2wAz6rZ9i9356DExA32aSKgl24iyxKjDnkxRkzt0MqSI5CCh6c2L8zVpt0UbcvMzk0qNWKfbXSD4j2yjvyw6BP4kUou6L1x1dryDJ2GY6KQpJ_37jYjDDdsVKlmx-4CgKXIdAK6IrCx9YMZwD0-TVjHzMvfJV_2eK31RfENKAEphlwOT2H1HPmbj3MzakoIMNtBSfIlSdWQTwLARx7NMktAw62Le6Sc8.ZWU0ZWIzMTktMWRhNi00Mzg0LTllMzYtNzlmMDU3MjRmYTkx",
    region: "us-east-1",
    style: "Standard",
    color_scheme: "Light",
  },
  coordsCenter: { lat: -34.90328, lng: -56.18816 },
  currencySymbol: "$U",
  decimalPattern: /^[0-9]+([.]\d{0,1})?$/,
  decimalNumber: 1,
  country: {
    defaultLocale: "es-UY",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/uy/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
  recaptcha_site_key: "6Le98o0sAAAAAMT-KoXGJs6OW-aYF9sbNdbigJaR",
  amazon_connect: {
    snippet_id:
      "QVFJREFIaGRXUHpDQ0syTWozT3FtUTlKL1lZeW8zbzdUZEQ4Y1A3d0wzMWFuQ0RFM0FIUjdSZEdzTzJWYWV1Ynl4NjY4QmRCQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNWXRNZ0JBWUpaUHM2NkhSSkFnRVFnQ3NiNFdUQ0xxSVVDVXBTRldTQzlGU0xSanRhYTFXWm5kMG85RWRBNnB6TDV0bnFRRnQ4V1JlVVhDVGg6OmNGZ0IwVjVrUEhIWlIwNDAyN0ZTTmtMcUpseTYvVlI0enFiSkpCWTVDazQxV3BlTmlKN2V6VDUyblpDYmswMjRlS3NIQnlWN2ZiN3NTNmN3UHBFdjczbGVWRDhkMDlBb25sTGgxUVlGcStIcC9wSVlISDhSa2orSjdDQVIwaEJTZEdNQWJML2g1OXIrZ1RNUWhReXFOSTNDS3puS2RRUT0=",
    src: "https://connect-rappi-support-prod.my.connect.aws/connectwidget/static/amazon-connect-chat-interface-client.js",
    script_id: "37223493-6644-445d-bae1-7074a64d629c",
  },
};
